import {
  takeLatest, call, put, select,
} from 'redux-saga/effects';
import axios from '../axiosConfig';
import { sendEmailCompare, sendEmailCompareResponse } from '../../slices/compare';
import getEmailRecipientsFromString from '../../../helpers/getEmailRecipientsFromString';
import formatStateroomsForRequest from '../../../helpers/formatters/formatStateroomsForRequest';
import getHotelPriceDisplayPreference from '../../../helpers/selectors/getHotelPriceDisplayPreference';

function* sendCompareWorker({
  payload: {
    compareTravelOptionsHtml,
  },
}) {
  try {
    const hotelRateDisplayPreference = yield select(getHotelPriceDisplayPreference(true));
    const { email: loggedInUserEmail } = yield select((store) => store.user);
    const { city } = yield select((store) => store.tripSearch.searchObj.cruise.filters);
    const {
      staterooms, car, flight, hotel,
    } = yield select((store) => store.tripSearch.searchObj);
    const {
      id,
      fromEmail,
      createdFor,
      emailRecipientsString,
      emailSubject,
      emailMessage,
      doSendCopyToAgent,
      doShowPricing,
      cruiseOptions,
      hotelOptions,
      flightOptions,
      tourOptions,
      carOptions,
    } = yield select((store) => store.compare);
    const url = `/compare/saveAndSend?doSendCopyToAgent=${doSendCopyToAgent}`;
    const config = {
      method: 'post',
      url,
      data: JSON.stringify({
        id,
        loggedInUserEmail,
        fromEmail,
        createdFor,
        emailRecipients: getEmailRecipientsFromString(emailRecipientsString),
        emailSubject,
        emailMessage,
        compareTravelOptionsHtml,
        doShowPricing,
        hotelRateDisplayPreference,
        compareTravelOptions: {
          passengerCity: city ? {
            code: city.value,
            name: city.label,
          } : null,
          roomSearchInput: staterooms.map((s) => formatStateroomsForRequest(s, cruiseOptions
            && cruiseOptions[0] && cruiseOptions[0].cruiseLine
            && cruiseOptions[0].cruiseLine.cruiseLineId)),
          cruiseOptions,
          hotelOptions,
          flightOptions: flightOptions?.filter((itinerary) => !itinerary?.flightItinerary
            ?.isIncompleteItinerary) || [],
          carOptions,
          tourOptions,
        },
        hotelRateCodesCsv: hotel && hotel.rateCodes && hotel.rateCodes.length ? hotel.rateCodes.join(',') : undefined,
        flightRateCodesCsv: flight && flight.rateCodes && flight.rateCodes.length ? flight.rateCodes.join(',') : undefined,
        rentalCarRateCodesCsv: car && car.rateCodes && car.rateCodes.length ? car.rateCodes.join(',') : undefined,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const { data } = yield call(axios, config);

    if (data) {
      yield put(sendEmailCompareResponse({
        data,
      }));
    } else {
      yield put(sendEmailCompareResponse({
        error: 'There is problem with your request. please try again.',
      }));
    }
  } catch (error) {
    console.error(error);
    let errorMessage = 'There is problem with your request. please try again.';
    if (error && error.response && error.response.data) {
      errorMessage = `${error.response.data.title} ${error.response.data.detail}`;
    }
    yield put(sendEmailCompareResponse({
      error: errorMessage,
    }));
  }
}

function* sendCompareWatcher() {
  yield takeLatest(sendEmailCompare.toString(), sendCompareWorker);
}

export default sendCompareWatcher;
